<template>
  <div id="app" class="app">
    <Home/>
  </div>
</template>
<script>
import Home from './views/Home'

export default {
  name: 'App',
  components: { Home },
  data () {
    return {}
  },
  computed: {},
  watch: {},
  methods: {},

}
</script>
<style lang="less">
.app {
  min-height: 100vh;
  width: 100vw;
  font-size: 0.16rem;

  & > {
    .fadeIn, .fadeOut {
      animation-duration: 0.5s;
    }
  }
}

</style>
